/* lib/table/tableSearch.js — правило поиска по таблицам Аналитики.

   ОДНО правило на все вкладки. До него «Ликвидность» искала своим
   `toLowerCase().includes()`, «Инвентаризация» — своим, а в ABC и «Продажах»
   поиска не было вовсе; «свекла» не находила «Свёклу» нигде, потому что «ё» в
   названиях кассы стоит через раз.

   Нормализация зеркалит серверную выгрузку (contracts/abc.md:
   `needle = q.strip().casefold().replace('ё', 'е')`): строки, которые человек
   видит в таблице, и строки в скачанном файле отбирает одно и то же правило.
   Разошлись бы — файл молча оказался бы уже экрана (шрам S19).

   Чистые функции без React: их проверяет vitest в node, а компонент поля и хук
   состояния живут в screens/analytics/TableSearch.jsx. */

/** Строка запроса или названия в сравнимом виде: без пробелов по краям,
 *  в нижнем регистре, «ё» → «е», «ß» → «ss» (так складывает сервер: Python
 *  `casefold`, а `toLowerCase` «ß» не трогает — «Weißbier» в выгрузке нашёлся
 *  бы, а на экране нет). null/undefined — пустая строка. */
export function normalizeSearch(s) {
  if (s == null) return '';
  return String(s).trim().toLowerCase().replace(/ё/g, 'е').replace(/ß/g, 'ss');
}

/** Есть ли что искать. Пробелы — не запрос: поле с одним пробелом не должно
 *  ни резать таблицу, ни считаться фильтром в счётчике. */
export function isSearchActive(needle) {
  return normalizeSearch(needle) !== '';
}

/** Подстрока по нормализованным строкам. Пустой запрос пропускает всё. */
export function matchesSearch(text, needle) {
  const n = normalizeSearch(needle);
  if (!n) return true;
  return normalizeSearch(text).includes(n);
}

/** Строки, чьё название (`get(row)`) подходит под запрос.
 *
 * Без запроса возвращает ТОТ ЖЕ массив, а не копию: результат уходит в
 * useMemo-цепочки отчётов (фильтры столбцов, группы, окно строк), и новый
 * массив на каждый рендер пересчитывал бы их все при пустом поле. Запрос
 * нормализуется один раз, а не на каждую строку. */
export function filterBySearch(rows, needle, get) {
  const list = Array.isArray(rows) ? rows : [];
  const n = normalizeSearch(needle);
  if (!n) return Array.isArray(rows) ? rows : list;
  return list.filter((row) => normalizeSearch(get(row)).includes(n));
}
